/**
 * Convert price in parts from priceFormatter.formatToParts and return price and currency
 * https://gitlab.agodadev.io/full-stack/price-display/react-handyman/-/blob/master/src/utils/priceFormatter/priceFormatter.ts
 */
var pricePartsToString = function pricePartsToString(parts) {
  var _parts$filter$;
  var currency = ((_parts$filter$ = parts.filter(function (p) {
    return p.type === 'currency';
  })[0]) === null || _parts$filter$ === void 0 ? void 0 : _parts$filter$.value) || '';
  var amount = parts.filter(function (p) {
    return p.type !== 'currency';
  }).map(function (p) {
    return p.value;
  }).join('');
  var alignCurrency = parts.indexOf(parts.filter(function (p) {
    return p.type === 'currency';
  })[0]) === 0 ? 'start' : 'end';
  return {
    currency: currency,
    amount: amount,
    alignCurrency: alignCurrency
  };
};

export { pricePartsToString };
//# sourceMappingURL=PriceHelper.js.map
